import { always, evolve } from "ramda";

import { catchStorageError } from "generic_helpers";
import { createReducer } from "../helpers";
import types from "action_types/tester_account/authentication_action_types";
import initialStore from "store/initial_state";

const reducers = [
  createReducer(
    types.SIGN_IN,
    (previousState, { payload: { authenticationToken, rememberMe, recognizedDeviceToken } }) => {
      let newState = previousState;

      const transformations = {
        testerAccount: {
          authenticationToken: always(authenticationToken),
          recognizedDeviceToken: always(recognizedDeviceToken),
        },
      };

      newState = evolve(transformations, newState);

      // rds as recognizedDeviceToken, avoiding too descriptive name for the user to easily see, they can still
      // find it out, but needs to dig deeper.
      localStorage.setItem("rdt", recognizedDeviceToken);

      if (rememberMe) {
        catchStorageError(() => {
          localStorage.setItem("testerAccountAuthenticationToken", newState.testerAccount.authenticationToken);
        });
      } else {
        catchStorageError(() => {
          sessionStorage.setItem("testerAccountAuthenticationToken", newState.testerAccount.authenticationToken);
        });
      }

      return newState;
    },
  ),

  createReducer(types.SIGN_OUT, previousState => {
    let newState = previousState;

    const transformations = {
      testerAccount: always(initialStore().testerAccount),
    };

    newState = evolve(transformations, newState);

    catchStorageError(() => {
      sessionStorage.removeItem("testerAccountAuthenticationToken");
      localStorage.removeItem("testerAccountAuthenticationToken");
    });

    return newState;
  }),
];

export default reducers;
